import { CoreModule } from "@modules/core/core.module";
import { NgModule } from "@angular/core";
import { CashPlusFiatTileUIComponent } from "./cashplus-fiat-tile.component";
import { BpValueChangeBadgeModule } from "@modules/shared/bp-value-change-badge/bp-value-change-badge.module";

@NgModule({
	declarations: [CashPlusFiatTileUIComponent],
	imports: [CoreModule, BpValueChangeBadgeModule],
	exports: [CashPlusFiatTileUIComponent]
})
export class CashPlusFiatTileUIModule {}
